"use client";

import i18next from "i18next";
import { useEffect, useState } from "react";
import {
  initReactI18next,
  useTranslation as useTranslationOrg,
} from "react-i18next";
import { useCookies } from "react-cookie";
import LanguageDetector from "i18next-browser-languagedetector";
import { getOptions, languages, cookieName } from "./settings";
import { FETCH_SETTINGS, LOCALIZATION_URL } from "@/lib/constants";
import { useSite } from "@/lib/hooks/site";
import getTDefaultOptions from "@/app/i18n/utilts";
import apiFetch from "@/lib/fetch";

const runsOnServerSide = typeof window === "undefined";

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .use({
    type: "backend",
    read: async (language, namespace, callback) => {
        try {
          const data = await apiFetch({
            externalURL: `${LOCALIZATION_URL}/locale?namespace=${namespace}&lng=${language}`,
            headers: {
              "Cache-Control": "no-cache"
            }
          });
          callback(null, data);
        } catch (e) {
          callback(e, {});
      }
    },
    create: () => {},
    init: () => {},
  })
  .init({
    ...getOptions(),
    lng: "tr",
    detection: {
      order: ["path", "htmlTag", "cookie", "navigator"],
    },
    preload: runsOnServerSide ? languages : [],
    interpolation: {
      escapeValue: false,
    },
  });

export function useClientTranslation(lng, ns, options) {
  const [cookies, setCookie] = useCookies([cookieName]);
  const ret = useTranslationOrg(ns, options);
  const { i18n, t: originalT } = ret;
  const site = useSite();

  const newT = (key, options = {}) => {
    const tOptions = getTDefaultOptions(key, options, site);

    return originalT(key, tOptions);
  };

  if (runsOnServerSide && lng && i18n.resolvedLanguage !== lng) {
    i18n.changeLanguage(lng);
  } else {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [activeLng, setActiveLng] = useState(i18n.resolvedLanguage);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
      if (activeLng === i18n.resolvedLanguage) return;
      setActiveLng(i18n.resolvedLanguage);
    }, [activeLng, i18n.resolvedLanguage]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
      if (!lng || i18n.resolvedLanguage === lng) return;
      i18n.changeLanguage(lng);
    }, [lng, i18n]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
      if (cookies.i18next === lng) return;
      setCookie(cookieName, lng, { path: "/" });
    }, [lng, cookies.i18next]);
  }

  return { ...ret, t: newT };
}
